













import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QuerySupplierList, DeleteSupplierInfo } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import { SupplierShopTypeFormat, SupplierStatusFormat } from '@/utils/tyepconvert'
import CreateSupplierDialog from './CreateSupplierDialog.vue'
import UpdateSupplierDialog from './UpdateSupplierDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    CreateSupplierDialog,
    UpdateSupplierDialog,
  },
})
export default class SupplierList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    endTime: '',
    endTimeq: null,
    sortType: 0,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private supplierOption: Array<any> = []
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '排序方式', param: 'sortType' , type: 'select', selectData: constant.SortType},
    { title: '门店', param: 'isShop', type: 'select', selectData: constant.SupplierShopType },
    { title: '合作状态', param: 'supplierStatus', type: 'select', selectData: constant.SupplierStatus },
    this.supplierQueryParam,
    { title: '供应商名称', param: 'supplierName' },
    { title: '供应商简称', param: 'supplierSimpleName' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建供应商', type: 'primary', click: this.openCreate }]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '供应商编号', param: 'supplierCode', overflow: true , width: 160},
    { title: '供应商名称', param: 'supplierName', overflow: true },
    { title: '供应商简称', param: 'supplierSimpleName', overflow: true },
    { title: '联系人', param: 'supplierContact'},
    { title: '联系方式', param: 'supplierMobilePhone'},
    { title: '是否门店', param: 'isShop', formatter: SupplierShopTypeFormat},
    { title: '合作状态', param: 'supplierStatus', formatter: SupplierStatusFormat },
    { title: '二维码内容', param: 'supplierCode', width:260, formatter: (d: string) => {return 'supplierPay?supplierCode='+d}},
    { title: '排序', param: 'sort' },
    { title: '创建时间', param: 'createTime',width: 100, formatter: DateFormat },
    {
      title: '操作',
      operation: [
        { title: '查看详情', icon: 'el-icon-document', click: this.openDesc },
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  private openCreate() {
    const d = this.$refs.CreateSupplierDialog as CreateSupplierDialog
    d.open()
  }

  private openDesc(data: any) { 
    const d = this.$refs.DescSupplierDialog as UpdateSupplierDialog
    d.open(data)
  }

  private openUpdate(data: any) {
    const d = this.$refs.UpdateSupplierDialog as UpdateSupplierDialog
    d.open(data)
  }

  public async created() {
    this.loadData()
    await this.loadSupplier()
  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  public async loadData() {
    const param: any = { ...this.queryParam }
    if (param.endTimeq) {
      param.endTime = ',' + param.endTimeq
    }
    if(this.queryParam.sortType == 0){
      param.orderBy = "sort desc, create_time desc"
    }

    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QuerySupplierList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteSupplierInfo({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
